import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { supabase } from '../api';

const SupabaseResetPassword = () => {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');

  const resetPassword = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const { error } = await supabase.auth.api.resetPasswordForEmail(email);

      if (error) throw error;
      alert('Password reset link sent to your email!');
      navigate('/', { replace: true });
    } catch (error) {
      alert(error.error_description || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component='main' maxWidth='sm'>
      <CssBaseline />
      <Grid item xs={12} lg={5.5} component={Paper} elevation={6} square>
        <Box
          sx={{
            p: 2,
            my: 8,
            mx: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component='h1' variant='h5'>
            Reset Password
          </Typography>
          <Box component='form' onSubmit={resetPassword} noValidate sx={{ mt: 1 }}>
            <TextField
              margin='normal'
              required
              fullWidth
              name='email'
              label='Email'
              type='email'
              id='email'
              autoComplete='current-email'
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button type='submit' fullWidth variant='contained' sx={{ mt: 3, mb: 2 }}>
              Reset Password
            </Button>
            <Typography component='subtitle1' sx={{ mt: '2rem' }}>
              Please wait a few minutes for the email to be sent. If you encounter any issues, feel free to reach out to
              us at hello@the100club.io
            </Typography>
            {loading ? <Box sx={{ padding: '2rem', mt: '2rem', textAlign: 'center' }}>Loading . . .</Box> : ''}
          </Box>
        </Box>
      </Grid>
    </Container>
  );
};
export default SupabaseResetPassword;
